















import {Component, Emit, Model, Vue, Watch, Prop} from 'vue-property-decorator';
import InputSelect from '@/layouts/back-office/elements/input/InputSelect.vue';
import {AppraisalType, AppraisalTypesVariables} from '@/types/auction';

@Component({
  components: {InputSelect},
})
export default class AppraisalTypeSelect extends Vue {
  @Model('change') protected model!: AppraisalType|null;
  @Prop(Object) protected variables?: AppraisalTypesVariables;

  protected value: string|null = null;

  @Watch('model', { immediate: true })
  protected onModelChange(value: AppraisalType|null) {
    this.value = (value) ? value.id : null;
  }

  @Emit('change')
  protected optionChange(value: AppraisalType) {
    return value;
  }

  @Emit('textChange')
  protected textChange(value: any) {
    return value;
  }
}
